module.exports = __webpack_public_path__ + "static/media/delete.3b316123.svg";